import type { CSSProperties, ReactNode } from 'react';
import { dataEl, type DataElScope } from '@/utils/dataEl';
interface CstretchmodalHeaderProps {
    dataElScope: DataElScope;
    header: ReactNode;
    style: CSSProperties;
}
export function CstretchmodalHeader({ dataElScope, header, style, }: CstretchmodalHeaderProps): ReactNode {
    if (!header) {
        return header;
    }
    return (
      <div data-el={dataEl(dataElScope, 'Header/Root')} style={style}>
        {header}
      </div>
    );
}
